import { recordPath, recordRoute } from '@/shared/registry'

/** Where the web page management pages live. */
export const webPagesPath = '/site-management/web-pages'
export const createWebPagePath = `${webPagesPath}/new`
export const webPageRoute = recordRoute('site-management', 'web-pages')
export const editWebPageRoute = `${webPageRoute}/edit`

/** Where a page opens by its id, for anyone who may see it. */
export const publishedWebPageRoute = '/pages/:publicId'

/** A web page's details page. */
export function webPagePath(id: string): string {
  return recordPath('site-management', 'web-pages', id)
}

/** Where a page opens for the people who may see it: its vanity URL, or its id. */
export function publishedWebPagePath(page: { readonly id: string; readonly vanityUrl?: string | null | undefined }): string {
  return page.vanityUrl === null || page.vanityUrl === undefined || page.vanityUrl === ''
    ? `/pages/${encodeURIComponent(page.id)}`
    : `/${page.vanityUrl}`
}

/** The base of Web Page Details' slots (`detailsSlots`). */
export const webPageDetailsSlot = 'site-management.web-page-details'

/** The API's web page endpoints. */
export const webPagesApi = '/site-management/v1/web-pages'

export function webPageApi(id: string): string {
  return `${webPagesApi}/${encodeURIComponent(id)}`
}

/** A page as the person opening it may see it, by id. */
export function publishedWebPageApi(id: string): string {
  return `${webPageApi(id)}/published`
}

/** A page as the person opening it may see it, by the address's path. */
export function webPageByVanityUrlApi(path: string): string {
  return `${webPagesApi}/by-vanity-url?path=${encodeURIComponent(path)}`
}

/** What each web page action needs; opening a disabled page also needs write. */
export const readWebPagesPermission = 'site-management.web-pages.read'
export const writeWebPagesPermission = 'site-management.web-pages.write'
export const deleteWebPagesPermission = 'site-management.web-pages.delete'
